function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 1597880510"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-24x24-History"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  d: "M11.6689 8.5C13.2325 8.5 14.5 9.77394 14.5 11.3454C14.5 12.8608 13.3214 14.0995 11.8352 14.186L11.6689 14.1909L10.4749 14.1899V15.1878H12.4599V17.1818H10.4749L10.4759 18.1788H8.49198L8.49098 17.1818H7.5V15.1878H8.49098L8.49198 8.5H11.6689ZM11.6689 10.494L10.4749 10.493V12.1959L11.6689 12.1969C12.1368 12.1969 12.516 11.8157 12.516 11.3454C12.516 10.9114 12.1929 10.5532 11.7752 10.5006L11.6689 10.494Z",
  fill: "#18CDA6"
})), /*#__PURE__*/React.createElement("path", {
  id: "Combined Shape",
  d: "M14.4423 0.5C16.0354 0.5 17.3269 1.84315 17.3269 3.5V4.5H17.8077C19.3439 4.5 20.5997 5.74892 20.6874 7.32373L20.6923 7.5V10.5C20.6874 10.6512 20.6923 11.3954 20.6923 12.5V15.5V18.5C20.6923 20.1569 19.4008 21.5 17.8077 21.5H3.38462C1.79149 21.5 0.5 20.1569 0.5 18.5V7.5C0.5 5.84315 1.79149 4.5 3.38462 4.5H3.86538V3.5C3.86538 1.90232 5.06627 0.596339 6.58051 0.505093L6.75 0.5H14.4423ZM17.8077 6.5H3.38462C2.85357 6.5 2.42308 6.94772 2.42308 7.5V18.5C2.42308 19.0523 2.85357 19.5 3.38462 19.5H17.8077C18.3387 19.5 18.7692 19.0523 18.7692 18.5V15.5C18.7692 15.5 18.7692 15.5 18.7692 12.5V7.5C18.7692 6.98716 18.398 6.56449 17.9198 6.50673L17.8077 6.5ZM14.4423 2.5H6.75C6.21896 2.5 5.78846 2.94772 5.78846 3.5V4.5H15.4038V3.5C15.4038 2.98716 15.0327 2.56449 14.5544 2.50673L14.4423 2.5Z",
  fill: "#18CDA6"
}));

var SvgServices = function SvgServices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/services.76d71aff.svg";
export { ForwardRef as ReactComponent };